var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"price"},[_c('li',{staticClass:"header",style:(_vm.getThemeStyle)},[_vm._v(_vm._s(_vm.title))]),_vm._l((15),function(i){return _c('li',{key:i + Math.random()},[_vm._v(" "+_vm._s(_vm.items[i] ? _vm.items[i].service : "")+" ")])})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }